export default "__VITE_ASSET__7kOvw2eo__"